import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{@title}}\n",{ moduleName: "frontend/components/twilio/modal/settings-title.hbs" })